var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jadecaps-logo-item"},[_c('img',{attrs:{"src":_vm.Image,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }